export default "__VITE_ASSET__CQ$rEvR3__"